import React, { useContext, useEffect } from 'react'
import { Section } from './AddNewPatient'
import {
  Alert,
  AlertTitle,
  Button,
  Grid,
  LinearProgress,
  Stack,
} from '@mui/material'
import { GlobalContext } from '../../../App'
import { regionLabels } from '../../../helpers/region'

const Submit = ({
  handleSubmit,
  showDuplicateNHSNoWarning,
  showMissingDataWarning,
  reducedDataset,
  addressUpdated,
  uploading,
}) => {
  const { tenantInfo } = useContext(GlobalContext)
  return (
    <Section>
      <Grid item xs={12}>
        <Stack gap={1}>
          {showDuplicateNHSNoWarning && (
            <Alert severity="error" variant="filled">
              A Patient with this {regionLabels(tenantInfo?.region).nationalIdLabel}{' '}
              already exists
            </Alert>
          )}
          {showMissingDataWarning && (
            <Alert severity="error" variant="filled">
              <AlertTitle color="white">Insufficient Data</AlertTitle>
              {reducedDataset
                ? "Please provide the patient's first and last name. A date of birth must be valid, and an address needs at least the first line and postcode."
                : "Please provide the patient's name, date of birth, address, and mobility category before submitting — the mobility category is used to dispatch the right vehicle."}
            </Alert>
          )}
          {addressUpdated && (
            <Alert severity="warning">
              <AlertTitle>Address has been updated</AlertTitle>
              The patient’s home address has been updated. Existing future
              journeys will not be changed automatically. Please edit the
              relevant journey or booking if those addresses also need updating.
            </Alert>
          )}
          {uploading && <LinearProgress color="contrast" />}
          <Button
            variant="contained"
            fullWidth
            color="anGreen"
            onClick={handleSubmit}
            disabled={uploading}
          >
            Submit
          </Button>
        </Stack>
      </Grid>
    </Section>
  )
}

export default Submit
